import { DEFAULT_LANGUAGES } from '../config/languages';

/** Resolve display label for a language code or name */
export const getLanguageLabel = (value) => {
  if (!value) return '';

  const str = String(value).trim();
  const lower = str.toLowerCase();

  const match = DEFAULT_LANGUAGES.find(
    (lang) =>
      lang.code.toLowerCase() === lower ||
      lang.label.toLowerCase() === lower
  );

  return match?.label || str;
};
